module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-590.3e8b4f2.woff2";